import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "absolute top-0 left-0 flex flex-col w-full h-full overflow-hidden" };
const _hoisted_2 = { class: "relative flex flex-col w-full h-full" };
const _hoisted_3 = { class: "absolute top-0 left-0 flex flex-col w-full h-full" };
const _hoisted_4 = { class: "flex items-center justify-between px-8 py-5 border-b border-gray-100 shrink-0 bg-white/60 backdrop-blur-sm" };
const _hoisted_5 = { class: "flex flex-col gap-0.5" };
const _hoisted_6 = { class: "text-2xl font-semibold text-gray-900" };
const _hoisted_7 = { class: "text-sm text-gray-500" };
const _hoisted_8 = ["disabled"];
const _hoisted_9 = {
    key: 0,
    class: "flex items-center gap-2.5 px-8 py-2.5 bg-amber-50 border-b border-amber-200 shrink-0"
};
const _hoisted_10 = { class: "text-sm text-amber-800" };
const _hoisted_11 = { class: "flex flex-col flex-1 gap-6 px-8 py-6 overflow-y-auto" };
const _hoisted_12 = {
    key: 0,
    class: "flex flex-col gap-2"
};
const _hoisted_13 = {
    key: 1,
    class: "flex items-center gap-3 p-4 border border-red-200 rounded-lg bg-red-50"
};
const _hoisted_14 = { class: "text-sm text-red-700" };
import { onMounted } from "vue";
import { useToast, POSITION } from "vue-toastification";
import { translateApp } from "@/i18n";
import { useChargeTemplates } from "../composables/useChargeTemplates";
import ChargeEmptyState from "./ChargeEmptyState.vue";
import ChargeTemplateTable from "./ChargeTemplateTable.vue";
import DeleteConfirmModal from "./DeleteConfirmModal.vue";
import DeleteBlockedModal from "./DeleteBlockedModal.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChargesIndex',
    setup(__props) {
        const toast = useToast();
        const { templates, editingId, pendingDeleteId, deleteBlockedBy, hasTemplates, isLoading, isSaving, error, templateById, fetchTemplates, startCreate, startEdit, cancelEdit, saveTemplate, requestDelete, cancelDelete, confirmDelete, clearDeleteBlocked, } = useChargeTemplates();
        onMounted(fetchTemplates);
        function handleNewCharge() {
            startCreate();
        }
        async function handleSave(dto) {
            try {
                await saveTemplate(dto);
                toast.success(translateApp("services.charges.toast.saved"), {
                    timeout: 3000,
                    position: POSITION.TOP_RIGHT,
                });
            }
            catch {
                toast.error(translateApp("services.charges.toast.save_error"), {
                    timeout: 4000,
                    position: POSITION.TOP_RIGHT,
                });
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t("services.charges.global.title")), 1),
                                    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("services.charges.global.description")), 1)
                                ]),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "flex items-center gap-2 px-4 py-2.5 text-sm font-medium text-white bg-egreen-500 rounded-lg hover:bg-egreen-600 transition-colors disabled:opacity-50",
                                    disabled: _unref(isLoading) || _unref(editingId) !== null,
                                    onClick: handleNewCharge
                                }, [
                                    _cache[1] || (_cache[1] = _createElementVNode("svg", {
                                        class: "w-4 h-4",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        "stroke-width": "2",
                                        stroke: "currentColor"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            d: "M12 4.5v15m7.5-7.5h-15"
                                        })
                                    ], -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t("services.charges.actions.new_charge")), 1)
                                ], 8, _hoisted_8)
                            ]),
                            (_unref(editingId) !== null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _cache[2] || (_cache[2] = _createElementVNode("svg", {
                                        class: "w-4 h-4 text-amber-500 shrink-0",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        "stroke-width": "2",
                                        stroke: "currentColor"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                                        })
                                    ], -1)),
                                    _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("services.charges.global.future_only_warning")), 1)
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_11, [
                                (_unref(isLoading))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                                            return _createElementVNode("div", {
                                                key: i,
                                                class: "h-12 bg-gray-100 rounded-lg animate-pulse"
                                            });
                                        }), 64))
                                    ]))
                                    : (_unref(error))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                            _cache[3] || (_cache[3] = _createElementVNode("svg", {
                                                class: "w-5 h-5 text-red-500 shrink-0",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                "stroke-width": "2",
                                                stroke: "currentColor"
                                            }, [
                                                _createElementVNode("path", {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    d: "M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
                                                })
                                            ], -1)),
                                            _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(error)), 1),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "ml-auto text-sm text-red-600 underline",
                                                onClick: _cache[0] || (_cache[0] =
                                                    //@ts-ignore
                                                    (...args) => (_unref(fetchTemplates) && _unref(fetchTemplates)(...args)))
                                            }, _toDisplayString(_ctx.$t("services.charges.actions.retry")), 1)
                                        ]))
                                        : (!_unref(hasTemplates) && _unref(editingId) === null)
                                            ? (_openBlock(), _createBlock(ChargeEmptyState, {
                                                key: 2,
                                                onCreate: handleNewCharge
                                            }))
                                            : (_openBlock(), _createBlock(ChargeTemplateTable, {
                                                key: 3,
                                                templates: _unref(templates),
                                                "editing-id": _unref(editingId),
                                                "is-saving": _unref(isSaving),
                                                onEdit: _unref(startEdit),
                                                onDelete: _unref(requestDelete),
                                                onSave: handleSave,
                                                onCancelEdit: _unref(cancelEdit),
                                                onAddRow: _unref(startCreate)
                                            }, null, 8, ["templates", "editing-id", "is-saving", "onEdit", "onDelete", "onCancelEdit", "onAddRow"]))
                            ])
                        ])
                    ])
                ]),
                (_unref(pendingDeleteId) !== null)
                    ? (_openBlock(), _createBlock(DeleteConfirmModal, {
                        key: 0,
                        "charge-name": _unref(templateById)(_unref(pendingDeleteId))?.name ?? '',
                        "is-deleting": _unref(isSaving),
                        onConfirm: _unref(confirmDelete),
                        onCancel: _unref(cancelDelete)
                    }, null, 8, ["charge-name", "is-deleting", "onConfirm", "onCancel"]))
                    : _createCommentVNode("", true),
                (_unref(deleteBlockedBy).length > 0)
                    ? (_openBlock(), _createBlock(DeleteBlockedModal, {
                        key: 1,
                        usages: _unref(deleteBlockedBy),
                        onClose: _unref(clearDeleteBlocked)
                    }, null, 8, ["usages", "onClose"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
